import { render } from "./CitizenshipsView.vue?vue&type=template&id=3dfc2870&scoped=true"
import script from "./CitizenshipsView.vue?vue&type=script&lang=js"
export * from "./CitizenshipsView.vue?vue&type=script&lang=js"

import "./CitizenshipsView.vue?vue&type=style&index=0&id=3dfc2870&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfc2870"]])

export default __exports__